import { formatAsBrNumber } from '~/prix'

export const stripParens = (s?: string | null) =>
  (s ?? '').replace(/\s*\(.*?\)\s*$/, '').trim() || null

export const formatBR = (v: number, opts?: Intl.NumberFormatOptions) => {
  try {
    return formatAsBrNumber(v)
  } catch {}
  return new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, ...opts }).format(v)
}

export const formatBRShort = (v: number) => {
  const abs = Math.abs(v)
  if (abs >= 1_000_000) return `${(v / 1_000_000).toFixed(abs % 1_000_000 ? 1 : 0)}M`
  if (abs >= 1_000) return `${(v / 1_000).toFixed(abs % 1_000 ? 1 : 0)}k`
  return formatBR(v)
}

export const formatPercent = (value: number | null | undefined) =>
  value == null || !isFinite(value) ? '—' : `${(value * 100).toFixed(2).replace('.', ',')}%`
